export default __webpack_public_path__ + "static/media/Agency-showcase.c26cbdf7.webp";